'use client';

import { useEffect, useContext } from 'react';
import { trackPostHogEvent } from './posthogUtils';
import { UserEngagementContext } from './userEngagementContext';
import { SourceContext } from './sourceContext';

export function TidioPosthogBridge() {

  const { setHasTidioInteracted } = useContext(UserEngagementContext);
  const { source } = useContext(SourceContext);

  useEffect(() => {
    function onTidioReady() {
      if (!window.tidioChatApi) return;

      // Get UTM source and send it as a tag to Tidio
      if (source) window.tidioChatApi.addVisitorTags([source]);

      window.tidioChatApi.on('open', () => {
        trackPostHogEvent('tidio_chat_open');
        setHasTidioInteracted(true);
      });

      window.tidioChatApi.on('conversationStart', () => {
        trackPostHogEvent('tidio_conversation_start');
      });

      window.tidioChatApi.on('messageFromVisitor', (payload) => {
        trackPostHogEvent('tidio_message_from_visitor', {
          message: payload?.message || '',
        });
      });

      window.tidioChatApi.on('messageFromOperator', (payload) => {
        trackPostHogEvent('tidio_message_from_operator', {
          message: payload?.message || '',
          from_bot: payload?.fromBot || false,
        });
      });
    }

    if (typeof window === 'undefined') return;

    if (window.tidioChatApi) {
      window.tidioChatApi.on('ready', onTidioReady);
    } else {
      document.addEventListener('tidioChat-ready', onTidioReady);
    }

    return () => {
      document.removeEventListener('tidioChat-ready', onTidioReady);
    };
  }, [setHasTidioInteracted, source]);

  return null;
}
